var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTheme(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.972 10.2167C14.108 9.89271 13.7193 9.61671 13.3933 9.76071C12.7417 10.0467 12.0376 10.1939 11.326 10.1927C8.536 10.1927 6.27467 7.97671 6.27467 5.24271C6.27364 4.3196 6.5359 3.41535 7.03067 2.63604C7.22 2.33737 6.99267 1.92404 6.646 2.01204C3.97333 2.69404 2 5.07537 2 7.90804C2 11.2727 4.78333 14 8.21733 14C10.8173 14 13.044 12.4367 13.972 10.2167Z",
    stroke: "#F3EDF3",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4064 2.06853C10.053 1.83253 9.6317 2.25386 9.86703 2.6072L10.287 3.2372C10.4574 3.49264 10.5483 3.79281 10.5483 4.09986C10.5483 4.40691 10.4574 4.70709 10.287 4.96253L9.86703 5.59253C9.6317 5.94586 10.0537 6.3672 10.407 6.1312L11.0364 5.7112C11.2918 5.54082 11.592 5.4499 11.899 5.4499C12.2061 5.4499 12.5063 5.54082 12.7617 5.7112L13.3917 6.1312C13.745 6.3672 14.1664 5.94586 13.9304 5.59253L13.5104 4.96253C13.34 4.70709 13.2491 4.40691 13.2491 4.09986C13.2491 3.79281 13.34 3.49264 13.5104 3.2372L13.9304 2.6072C14.1664 2.25386 13.745 1.83253 13.391 2.06853L12.7617 2.48853C12.5063 2.65891 12.2061 2.74983 11.899 2.74983C11.592 2.74983 11.2918 2.65891 11.0364 2.48853L10.4064 2.06853V2.06853Z",
    stroke: "#F3EDF3",
    strokeWidth: 1.33333
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTheme);
export default __webpack_public_path__ + "static/media/theme.3710adfef4303b910c47329c995a5fa0.svg";
export { ForwardRef as ReactComponent };